const getSubdomain = (server) => {
  switch (server) {
  case 'production':
    return 'mezzo'
  case 'validation':
    return 'valid-api'
  case 'smartlink':
    return 'smartlink'
  default:
    return 'valid-api'
  }
}


export default getSubdomain
